import toastTrigger from '@ui/toast/toast-trigger';

export const cannotDeleteToast = (errorMessage: string) =>
  toastTrigger(
    <div className="S1">
      <div>Could not delete</div>
      <div>The following content must be removed from all projects before being deleted: {errorMessage}</div>
    </div>,
    {
      type: 'error',
      autoClose: 10000,
    }
  );
